<template>
<div class="vertical-align-wrap">
  <div class="vertical-align-middle auth-main">
    <div class="auth-box">
      <div class="top">
        <img src="../assets/img/logo.svg" alt="UOI">
      </div>
      <div class="card">
        <div class="header">
            <p class="lead">Create an account</p>
        </div>
        <div class="body">
          <div class="form-group form-row">
            <div class="col">
              <label for="first-name" class="control-label sr-only">First Name</label>
              <input type="text" class="form-control" id="first-name" placeholder="First Name" v-model="signup.firstName">
            </div>
            <div class="col">
              <label for="last-name" class="control-label sr-only">Last Name</label>
              <input type="text" class="form-control" id="last-name" placeholder="Last Name" v-model="signup.lastName">
            </div>
          </div>
          <div class="form-group">
            <label for="signup-email" class="control-label sr-only">Email</label>
            <input type="email" class="form-control" id="signup-email" placeholder="Your email" v-model="signup.email">
          </div>
          <div class="form-group">
            <label for="signup-password" class="control-label sr-only">Password</label>
            <input type="password" class="form-control" id="signup-password" placeholder="Password" v-model="signup.password">
          </div>
          <button class="btn btn-primary btn-lg btn-block" @click="save">REGISTER</button>
          <div class="bottom">
            <span class="helper-text">Already have an account? <router-link to="" @click.native="login">Login</router-link></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import api from '../services/api'
import { SignUp } from '../models/signup'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      signup: {
        ...SignUp
      },
      isHidden: false
    }
  },
  methods: {
    ...mapActions(['appLogin']),
    async save() {
        const signUpApi = api('member-management')
        await signUpApi.create(this.signup)
        this.$router.go(-1)
    },
    login() {
      this.$router.push({ name: 'login' })
    },
  }
}
</script>